<template lang="pug">
section#faq.section.page-section.top-section
  .dark-header.centered
    .container.is-fluid
      h4.is-size-2.has-text-weight-semibold {{ page.h1 }}
      h4.is-size-4 {{ page.h2 }}
  section.section.page-section
    .container.is-fluid.mobile-padding
      .columns
        .column.is-two-thirds
          .content
            span(v-html="$options.filters.markdown(page.body)")
        .column.is-one-third
          location-card
</template>

<script>
import { mapGetters } from 'vuex';
import LocationCard from '@/components/LocationCard.vue';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'faq',
  computed: {
    ...mapGetters({
      page: getterTypes.GET_PAGE,
    }),
  },
  components: {
    LocationCard,
  },
};
</script>

<style lang="scss">
#faq {
  .dark-header {
    background-image: url('/static/images/church-header.jpg');
    background-size: cover;
    background-position: left;
  }
  .content {
    p + h4 {
      margin-top: 0.5rem;
    }
    strong {
      font-weight: 600;
      display: block;
    }
  }
}
</style>
